import { Component, Input } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

@Component({
  selector    : 'add-from-recipe',
  templateUrl : 'add-from-recipe.html',
  styleUrls   : [ 'add-from-recipe.scss' ]
})

export class AddFromRecipeComponent {
  @Input() recipes;

  constructor(
    private firebaseService: FirebaseService
  ) {}

  add(event) {
    const tempArr : string[] = event.target.value.split(/\|\|\|/);

    this.firebaseService.getItemsFromRecipe(tempArr[1])
      .take(1)
      .subscribe(ingredients => {
        this.firebaseService.createBulkItems(ingredients, tempArr[0])
          .then(() => event.target.value = null);
      });
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/add-from-recipe/add-from-recipe.ts